import { useEpisodeBeingEdited } from '@app/organisms/EpisodeEditForm/EpisodeEditFormContext';
import useShowNewsletterTemplateQuery from '@queries/newsletter/useShowNewsletterTemplateQuery.hook';
import EpisodeEditFormNewsletterEditor from '@app/organisms/EpisodeEditForm/EpisodeEditFormNewsletter/EpisodeEditFormNewsletterEditor';
import { useFormContext } from 'react-hook-form';
import { EPISODE_PRIVACY } from '@/utils/constants';
import NewsletterDisabled from '@app/organisms/EpisodeEditForm/EpisodeEditFormNewsletter/NewsletterDisabled';
import NewsletterNotAllowed from '@app/organisms/EpisodeEditForm/EpisodeEditFormNewsletter/NewsletterNotAllowed';
import styled from 'styled-components';
import Spinner from '@ui/atoms/Spinner';
import EpisodeEditFormNewsletterError from '@app/organisms/EpisodeEditForm/EpisodeEditFormNewsletter/EpisodeEditFormNewsletterError';

const LoadingWrapper = styled.div`
    height: 10rem;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const EpisodeEditFormNewsletter = () => {
    const episode = useEpisodeBeingEdited();
    const { watch } = useFormContext();

    const privacy = watch('privacy.privacy');
    const isEpisodePublic = privacy === EPISODE_PRIVACY.PUBLIC;

    const showNewsletterTemplateQuery = useShowNewsletterTemplateQuery(episode.show.id);

    if (showNewsletterTemplateQuery.isLoading) {
        return (
            <LoadingWrapper>
                <Spinner size={32} />
            </LoadingWrapper>
        );
    }

    if (showNewsletterTemplateQuery.error) {
        // Current show does not have newsletter settings yet
        const noNewsletterSettings = showNewsletterTemplateQuery.error.response?.status === 404;

        if (noNewsletterSettings) {
            return <NewsletterDisabled />;
        } else {
            return <EpisodeEditFormNewsletterError />;
        }
    }

    const { data: showNewsletterTemplate } = showNewsletterTemplateQuery;

    // Newsletter is not enabled for the show
    if (!showNewsletterTemplate.activated) {
        return <NewsletterDisabled />;
    }

    if (!isEpisodePublic) {
        return <NewsletterNotAllowed />;
    }

    return <EpisodeEditFormNewsletterEditor />;
};

export default EpisodeEditFormNewsletter;
